import { render, staticRenderFns } from "./UserAuthPopup.vue?vue&type=template&id=7b4c2540&scoped=true"
import script from "./UserAuthPopup.vue?vue&type=script&lang=js"
export * from "./UserAuthPopup.vue?vue&type=script&lang=js"
import style0 from "./UserAuthPopup.vue?vue&type=style&index=0&id=7b4c2540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c2540",
  null
  
)

export default component.exports